import { extend } from 'vee-validate';
import { validator } from './runtime';

extend('scheduler', {
    ...validator,
    message: 'The code you entered is not valid or incomplete for this provider'
});
